import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Urls } from '../../../../utils/catalogue/urls';
import { ApiService } from '../../../../shared/catalogue/services/api.service';
import { CommonDataService } from '../../../../shared/catalogue/services/common-data.service';
import { DATA_PER_PAGE, CANCEL, File_deleted } from './../../../../../app/app.constant';

const MAX_FILE_SIZE = 1000000;
@Component({
  selector: 'app-forms-sebi',
  templateUrl: './forms-sebi.component.html',
  styleUrls: ['./forms-sebi.component.scss'],
})
export class FormsSebiComponent implements OnChanges {
  @Input() data: any[] = [];

  sebiPDFsData: any[] = [];

  pageSize: number = DATA_PER_PAGE;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.data) {
      this.filterPdf(this.data);
    }
  }

  getDocs = () => {
    this.apiService.getData(Urls.getSectionDocs).subscribe((response: any) => {
      this.filterPdf(response.data.list);
    });
  };

  public filterPdf(data: any[]) {
    const sebiPDFsData = data.filter((pdf) => {
      return pdf.type === 'Circulars' || pdf.type === '5';
    });

    this.sebiPDFsData = [...sebiPDFsData];
  }

  viewFile = (path) => {
    window.open(path, '_blank');
  };

  deleteData = (id) => {
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteSectionDocuments, { id })
            .subscribe((response: any) => {
              this.toastr.success(File_deleted);
              this.getDocs();
            });
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  };
}
